import axiosInstance from "../lib/axiosInstance";
import axiosInstanceNew from "../lib/axiosinstanceNew";
const Tutorsmodel = class {
  constructor() {
    this.baseUrl = "/adminapi/tutor/";
    this.staticData = [
      {
        id: 1,
        user: {
          id: 1,
          first_name: "Rajesh",
          last_name: "Kumar",
        },
      },
      {
        id: 2,
        user: {
          id: 2,
          first_name: "Priya",
          last_name: "Sharma",
        },
      },
      {
        id: 3,
        user: {
          id: 3,
          first_name: "Amit",
          last_name: "Singh",
        },
      },
      {
        id: 4,
        user: {
          id: 4,
          first_name: "Sunita",
          last_name: "Patel",
        },
      },
      {
        id: 5,
        user: {
          id: 5,
          first_name: "Vikram",
          last_name: "Gupta",
        },
      },
      {
        id: 6,
        user: {
          id: 6,
          first_name: "Meera",
          last_name: "Joshi",
        },
      },
      {
        id: 7,
        user: {
          id: 7,
          first_name: "Arun",
          last_name: "Verma",
        },
      },
      {
        id: 8,
        user: {
          id: 8,
          first_name: "Kavita",
          last_name: "Mishra",
        },
      },
    ];

    // Static data for tutor profile
    this.staticTutorProfile = {
      id: 1,
      dob: "1990-05-15",
      english_fluency: "8",
      availability: "available",
      note: "Experienced mathematics tutor with 5+ years of teaching experience",
      tutor_status: ["Adaptable & Reliable,Dedicated & Professional"],
    };

    // Static data for personal information
    this.staticPersonalInfo = {
      id: 1,
      phone: "+91-9876543210",
      address: "123 Main Street, Mumbai, Maharashtra",
      emergency_contact: "+91-9876543211",
      aadhar_number: "1234-5678-9012",
      pan_number: "ABCDE1234F",
    };

    // Static data for teaching preferences interview
    this.staticInterviewData = [
      {
        id: 1,
        subject: "Mathematics",
        grade: "Class 10",
        experience_years: 5,
        preferred_timing: "Evening",
        teaching_mode: "Online",
      },
      {
        id: 2,
        subject: "Physics",
        grade: "Class 12",
        experience_years: 3,
        preferred_timing: "Morning",
        teaching_mode: "Offline",
      },
    ];

    // Static data for teaching preferences
    this.staticTeachingPreferences = [
      {
        id: 1,
        preference: [
          { name: "Mathematics" },
          { name: "CBSE" },
          { name: "Class 10" },
          { name: "Algebra" },
        ],
        answer: "https://example.com/answer1.pdf",
        status: "Active",
      },
      {
        id: 2,
        preference: [
          { name: "Physics" },
          { name: "ICSE" },
          { name: "Class 12" },
          { name: "Mechanics" },
        ],
        answer: "https://example.com/answer2.pdf",
        status: "Active",
      },
      {
        id: 3,
        preference: [
          { name: "Chemistry" },
          { name: "State Board" },
          { name: "Class 11" },
          { name: "Organic Chemistry" },
        ],
        answer: "https://example.com/answer3.pdf",
        status: "Hold",
      },
    ];

    // Static data for tutor profile details
    this.staticTutorProfileDetails = {
      id: 1,
      qualification: "M.Sc Mathematics",
      experience: "5 years",
      specialization: "Algebra, Geometry, Calculus",
      certifications: ["B.Ed", "CTET"],
      languages: ["English", "Hindi"],
    };

    // Static data for tutor details
    this.staticTutorDetails = {
      id: 1,
      user: {
        first_name: "Rajesh",
        last_name: "Kumar",
      },
      subjects: ["Mathematics", "Physics"],
      classes: ["Class 9", "Class 10", "Class 11", "Class 12"],
      rating: 4.5,
      total_students: 25,
      completed_sessions: 150,
    };
  }

  async Tutorslist(status, query = []) {
    return (
      await axiosInstanceNew.get(
        `tutors${status}&${new URLSearchParams(query)}`
      )
    ).data;
  }
  async Tutorslistcount(status) {
    return (await axiosInstanceNew.get(`tutors${status}`)).data;
  }
  //
  // async Tutorslist(query = []) {
  //  return (
  //    await axiosInstance.get(`adminapi/tutorlist/?${new URLSearchParams(query)}`)).data;
  //}
  //get tutor profile
  async Gettutorprofile(id) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: {
          data: this.staticTutorProfile,
        },
      };
    } catch (error) {
      console.error("Error fetching tutor profile:", error);
      throw error;
    }
  }
  // get all tutor list
  async GetAllTutor() {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: this.staticData,
      };
    } catch (error) {
      console.error("Error fetching tutors data:", error);
      throw error;
    }
  }
  // tutor detail
  async tutordetail(tutor_id, enquiry_id) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return this.staticTutorDetails;
    } catch (error) {
      console.error("Error fetching tutor details:", error);
      throw error;
    }
  }
  // add tutor
  async addtutor(data = []) {
    return await axiosInstanceNew.post(
      `enquiry/shortlisted_tutors/addProfile`,
      data
    );
  }
  //linked tutor
  async linkedtutor(data = []) {
    return await axiosInstanceNew.post(`enquiry/linked_tutors`, data);
  }
  async Unlinkedtutor(data = {}) {
    return await axiosInstanceNew.delete(`enquiry/linked_tutors/unlink`, {
      data: data, // Pass the payload in the `data` property
    });
  }
  // get linked tutor
  async getlinkedtutor(id) {
    return await axiosInstanceNew.get(
      `enquiry/linked_tutors/?enquiry_id=${id}`
    );
  }
  // made schedule demo
  async scheduledemo(data = []) {
    return await axiosInstanceNew.post(`enquiry/linked_tutors/addDemo`, data);
  }
  // given demo
  async demogiven(data = []) {
    return await axiosInstanceNew.post(`enquiry/linked_tutors/demoGiven`, data);
  }
  // create Pakage
  async createpakage(data) {
    return await axiosInstanceNew.put(
      `enquiry/linked_tutors/createPackage`,
      data
    );
  }
  async tutorslistallData(query = []) {
    return (await axiosInstance.get(`${this.baseUrl}?page=1&size=100`)).data;
  }

  async listbyTutorsid(data = []) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: {
          data: [this.staticTutorProfileDetails],
        },
      };
    } catch (error) {
      console.error("Error fetching tutor data by ID:", error);
      throw error;
    }
  }

  async TeachingPreferencelist(data = []) {
    // Return static data for teaching preferences
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: this.staticTeachingPreferences,
            meta: {
              current_page: 1,
              per_page: 20,
            },
          },
        });
      }, 500);
    });
    // return await axiosInstance.get(`/adminapi/teachps/?id=${data.id}`);
    // await axiosInstance.get(`${this.baseUrl}`,{params:data})
  }

  async TutorsClasslist(id = []) {
    return await axiosInstance.get(`/adminapi/c-class/?tutor=${id}`);
    // await axiosInstance.get(`${this.baseUrl}`,{params:data})
  }

  async TeachingPreferenceInterviewlist(id, parmeter = []) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: {
          data: this.staticInterviewData,
        },
      };
    } catch (error) {
      console.error("Error fetching interview data:", error);
      throw error;
    }
  }
  // async Tutorslist(query=[])
  // {
  //     return (await axiosInstance.get(`${this.baseUrl}?${new URLSearchParams(query)}`)).data;
  // }

  async TeachingshInterviewQualifiedSubject(id = []) {
    return await axiosInstance.get(`/adminapi/shinterview/?id=${id}`);
    // await axiosInstance.get(`${this.baseUrl}`,{params:data})
  }

  async TeachingLocationlist(data = []) {
    return await axiosInstance.get(`/adminapi/tl/?id=${data.id}`);
    // await axiosInstance.get(`${this.baseUrl}`,{params:data})
  }
  async TeachingQualificationlist(data = []) {
    return await axiosInstance.get(`/adminapi/qual/?tid=${data.id}`);
    // await axiosInstance.get(`${this.baseUrl}`,{params:data})
  }
  async PersonalInformationlist(data = []) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: {
          data: this.staticPersonalInfo,
        },
      };
    } catch (error) {
      console.error("Error fetching personal information:", error);
      throw error;
    }
  }
  async TeachingExperienceslist(data = []) {
    return await axiosInstance.get(`/adminapi/exp/?tid=${data.id}`);
    // await axiosInstance.get(`${this.baseUrl}`,{params:data})
  }

  async interviewStatusChnage(data) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const jsonData = JSON.stringify(data);
      const response = await axiosInstance.post(
        "/adminapi/cinterview/",
        jsonData,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating class:", error);
      throw error; // Rethrow the error for handling at the calling site
    }
  }

  async createTutorsProfile(data) {
    console.log(data, "classmodal");
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const jsonData = JSON.stringify(data);
      const response = await axiosInstance.post(
        "/adminapi/tutor_profile/",
        jsonData,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating class:", error);
      throw error; // Rethrow the error for handling at the calling site
    }
  }

  async editTutorsProfile(data) {
    console.log(data, "classmodal");
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const jsonData = JSON.stringify(data);
      const response = await axiosInstance.put(
        "/adminapi/tutor_profile/",
        jsonData,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating class:", error);
      throw error; // Rethrow the error for handling at the calling site
    }
  }

  async TutorsProfileGet(id = []) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: {
          data: this.staticTutorProfileDetails,
        },
      };
    } catch (error) {
      console.error("Error fetching tutor profile details:", error);
      throw error;
    }
  }

  async removeTutors(data = {}) {
    return await axiosInstance.delete(this.baseUrl, { data: data });
  }

  async createTutors(data = []) {
    return await axiosInstance.post(this.baseUrl, data);
  }

  async editTutors(data = []) {
    return await axiosInstance.put(this.baseUrl, data);
  }
  // Get notification
  async GetAllNotificaton(query = []) {
    return await axiosInstanceNew.get(
      `notification?${new URLSearchParams(query)}`
    );
  }
};

export default new Tutorsmodel();
